import $ from "jquery";
import { orderDirection, selectedCategories } from "../pages/blog";
import initDebounce from "../utilities/debounce";

export default function LoadMore() { 
    initDebounce( $ );

    const btn = document.getElementById('loadmore');

    if (btn){
        const listWrapper = btn.dataset.listWrapper
        const postType = btn.dataset?.postType || 'articles';
        const taxonomy = btn.dataset?.taxonomy || 'course-category';
        const partial = btn.dataset?.partial || 'templates/partials/ajax_card_list_default';
        const termId = btn.dataset?.termId || null;
        const authorQuery = btn.dataset?.authorQuery || null;
        const withFeaturedPost = btn.dataset?.withFeaturedPost || false;
        let currentPage = 1
    
        btn.addEventListener('click', onLoadMore)

        $( window ).on( { 
            "categories-changed": $.debounce( 150, onChangeCategory ) 
        } );

        function selectedTerms() {
            return Object.assign([], [termId])
        }

        function onLoadMore() {
            currentPage++;
            
            onAjaxLoad(
                currentPage,
                termId ? selectedTerms() : $( "#category-filter" ).length ? selectedCategories() : [],
                $( "#sort-by" ).length ? orderDirection() : 'DESC')
            .then(function(result) {
                // const result = JSON.parse(res);
    
                if(result.isEnd) {
                    $('#loadmore').hide();
                }
    
                $('#loadmore').text('Load More');
                $('#loadmore').prop('disabled', false);
                $(`${listWrapper}`).append(result.html);
            })
        }

        function onChangeCategory() {
            currentPage = 1;
            
            onAjaxLoad(
                currentPage,
                termId ? selectedTerms() : $( "#category-filter" ).length ? selectedCategories() : [],
                $( "#sort-by" ).length ? orderDirection() : 'DESC')
            .then(function(result) {    
                if(result.isEnd) {
                    $('#loadmore').hide();
                }
    
                $('#loadmore').text('Load More');
                $('#loadmore').prop('disabled', false);
                $(`${listWrapper}`).html(result.html);
            })
        }

        async function onAjaxLoad(page, categories, order = "DESC") {

            const response = await $.ajax( {
                url: `${ window.location.origin }/wp-admin/admin-ajax.php`,
                method: 'POST',
                data: {
                    action: 'vl_ajax_load_more',
                    post_type: postType,
                    partial: partial,
                    paged: page,
                    categories: categories,
                    is_term_id: termId ? true : false,
                    with_featured_post: withFeaturedPost,
                    order: order,
                    taxonomy: taxonomy,
                    author: authorQuery
                },
                xhr: function() {
                    var xhr = new window.XMLHttpRequest();
            
                    xhr.addEventListener("progress", function(evt) {
                        if (evt.lengthComputable) {
                            $('#loadmore').text('Loading...');
                            $('#loadmore').attr('disabled', true);
                        }
                    }, false);
            
                    return xhr;
                },
            })

            if ( ( ! response ) || ( ! response.status ) ) {
                console.error( "Failure to load more data.." );
                return null; 
            }

            return response;
        }
    }
}